import { map } from 'ramda';

import { InterpolationWithTheme } from '@emotion/core';

function composeStyles<Theme>(
  styles: InterpolationWithTheme<Theme>[],
): InterpolationWithTheme<Theme> {
  return (theme: Theme) => {
    return map(
      style => (typeof style === 'function' ? style(theme) : style),
      styles,
    );
  };
}

export default composeStyles;
